import { createSlice } from '@reduxjs/toolkit';

const initial = { isShow: false };

const popupSlice = createSlice({
  name: 'popup',
  initialState: {
    step1ForOTP: initial,
    changePhoto: initial,
    serviceDesk: initial,
    phoneNumber: initial,
    pslTrmsDetailPopup: initial,
    JobRankNTitleInfoTip:initial,
  },
  reducers: {
    openStep1ForOTP: state => {
      state.step1ForOTP.isShow = true;
    },
    closeStep1ForOTP: state => {
      state.step1ForOTP.isShow = false;
    },
    openPhoneNumber: state => {
      state.phoneNumber.isShow = true;
    },
    closePhoneNumber: state => {
      state.phoneNumber.isShow = false;
    },
    openChangePhoto: state => {
      state.changePhoto.isShow = true;
    },
    closeChangePhoto: state => {
      state.changePhoto.isShow = false;
    },
    openServiceDesk: state => {
      state.serviceDesk.isShow = true;
    },
    closeServiceDesk: state => {
      state.serviceDesk.isShow = false;
    },
    openPslTrmsDetailPopup: state => {
      state.pslTrmsDetailPopup.isShow = true;
    },
    closePslTrmsDetailPopup: state => {
      state.pslTrmsDetailPopup.isShow = false;
    },
    openJobRankNTitleInfoTip: state => {
      state.JobRankNTitleInfoTip.isShow = true;
    },
    closeJobRankNTitleInfoTip: state => {
      state.JobRankNTitleInfoTip.isShow = false;
    },
  },
});

export const {
  openStep1ForOTP,
  closeStep1ForOTP,
  openPhoneNumber,
  closePhoneNumber,
  openChangePhoto,
  closeChangePhoto,
  openServiceDesk,
  closeServiceDesk,
  openPslTrmsDetailPopup,
  closePslTrmsDetailPopup,
  openJobRankNTitleInfoTip,
  closeJobRankNTitleInfoTip
} = popupSlice.actions;
export default popupSlice.reducer;
